import React from 'react';
import { AlreadyRatedComponent, RatedComponent } from '../common'


const ReviewApartmentComponent = () => {
  const ratingApartment = localStorage.getItem('ratingApartment');

  return (
    <>
      <div className="user-rating-review my-5">
        <div className="container">
          <div className="page-for-owners">
            <div className="row">
              <div className="col-12">
                <div className="rating-form box-white">
                  {ratingApartment ? <RatedComponent/> :<AlreadyRatedComponent/> }
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ReviewApartmentComponent;
